import { render } from "./MonedaShow.vue?vue&type=template&id=378c5dbf"
import script from "./MonedaShow.vue?vue&type=script&lang=js"
export * from "./MonedaShow.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__